import { z } from "zod";

export const lensIdSchema = z.enum(["persona", "domain_expert"]);
export type LensId = z.infer<typeof lensIdSchema>;

export const lensAvailabilitySchema = z.object({
  id: lensIdSchema,
  label: z.string(),
  icon: z.string(),
  available: z.boolean(),
  reason: z.string().optional(),
});
export type LensAvailabilityInfo = z.infer<typeof lensAvailabilitySchema>;

export const lensVerdictSchema = z.object({
  lensId: lensIdSchema,
  summary: z.string(),
  findingCount: z.number(),
});
export type LensVerdict = z.infer<typeof lensVerdictSchema>;
